import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=edb1197a&scoped=true&"
import script from "./Suspension.vue?vue&type=script&lang=js&"
export * from "./Suspension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb1197a",
  null
  
)

export default component.exports